import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from "react";

import TableContainer from '@material-ui/core/TableContainer';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//Controllers

import { headerSearch, unoTheme } from '../../../assets/styles/unoTheme';

import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Menu, MenuItem, Paper, Radio, TextField, Tooltip } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import GridOn from "@material-ui/icons/GridOn";
import Remove from '@material-ui/icons/HighlightOff';
import { Bar } from "react-chartjs-2";
import { ClientAPI } from "../../../API/client";
import { ComDinheiroAPI } from "../../../API/comdinheiro-api";
import { FundAPI } from "../../../API/fund";
import { FundGroupsAPI } from "../../../API/fund_groups";
import { LocalBenchMarksAPI } from "../../../API/local_benchmaks";
import { REQ_COMDINHEIRO_TYPE } from "../../../API/reqs_comdinheiro";
import MyAutoComplete from "../../utils/MyAutoComplete";
import MyRadioGroup from "../../utils/MyRadioGroup";
import MySelect from "../../utils/MySelect";
import MyTextField from "../../utils/MyTextField";
import UnoButton from "../../utils/UnoButton";
import { applyMaskAmount, applyMaskAmountComdinheiro, applyMaskAmountComdinheiroFreeDecimals, formatMillionNumber, formatStringToDisplay, getDayMonthsAgo, getDayMonthYearByDate, getDayMonthYearByPtDate, getReferenceDate, isValidCnpj } from "../../utils/utils";
import { getCodeToComdinheiroQuotas } from '../../../controllers/FundController';
import { s2ab, downloadBlob } from '../../../controllers/ExcelController';
import * as XLSX from 'xlsx';

const maxFundsInCompare = 20;
const widthFundsInCompare = 15;
const widthCompare = 100 - widthFundsInCompare;

const optionsChartRentsMonth = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
    scales: {
        yAxes: [{
            ticks: {
                callback: function (value, index, values) {
                    return value + '%';
                }
            }
        }],
    },

    tooltips: {
        callbacks: {
            label: function (tooltipItem) {
                return applyMaskAmount(tooltipItem.yLabel) + '%';
            }
        }
    },

}

const optionsChartPatrimonio = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'bottom',
        fullWidth: true,
    },
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                    return formatMillionNumber(value);
                }
            }
        }],
    },

    tooltips: {
        callbacks: {
            label: function (tooltipItem) {
                return applyMaskAmount(tooltipItem.yLabel, true);
            }
        }
    },

}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    rightHeader: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
    },

    fundsInCompare: {
        overflowY: 'scroll',
        width: `${widthFundsInCompare}%`,
        height: '100%',
        padding: '16px',

        '&::-webkit-scrollbar': {
            width: '5px',
        },

        '&::-webkit-scrollbar-track': {
            background: '#c3c3c3',
        },
        '&::-webkit-scrollbar-thumb': {
            background: unoTheme.mainColor,
            borderRadius: '10px',
        },

        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        '& .fundInCompare': {
            '& .cardFund': {
                borderRadius: '4px',
                padding: '8px 16px',
                textAlign: 'left',
                '& .cardFundTop': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',

                    '& .segment': {
                        fontSize: '12px',
                        marginBottom: '4px'
                    },

                    '& .removeFund': {
                        cursor: 'pointer',
                    },
                },
                '& p': {
                    margin: '0px',
                },
                '& .fundName': {
                    fontSize: '12px',
                },
                '& .cnpj': {
                    fontSize: '12px',
                    fontWeight: 'bold'
                },
            }
        }
    },

    dividerFunds: {
        width: '5px',
        backgroundColor: unoTheme.mainColor,
        borderRadius: '20px',
        height: 'calc(100% - 32px)',
        marginTop: '16px',
        padding: '16px 0px',
    },

    comparativeLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },

    centerButton: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        '& .compareButton': {
            marginTop: -38.750,
        }
    },

    compareCharts: {
        padding: '16px',
        display: 'flex',
        flex: 1,
        width: `calc(${widthCompare}% - 5px)`,
        maxWidth: `calc(${widthCompare}% - 5px)`,
        height: '100%',
        overflowY: 'scroll',

        '& .loadChart': {
            borderRadius: '10px',
            background: "#eeeeee",
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },

        '& .loadPatrimony': {
            height: '400px',
        },

        '& .loadRiskReturn': {
            height: '200px',
        },
    },
    gridPaperTable: {
        borderRadius: '10px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),

        '& .title': {
            color: '#768191',
        },

        '& .MuiTypography-root': {
            paddingLeft: theme.spacing(2),
            paddingBottom: theme.spacing(1),
        }
    },
    divChart: {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        justifyContent: 'center',

        '& .chartHeader': {
            minHeight: '56px',
            height: '56px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            paddingBottom: '12px',
            paddingRight: '13px',

            '& .MuiTypography-root': {
                marginRight: '8px',
            },

            '& .right': {
                display: 'flex',
                alignItems: 'center',
            }
        },

        '& .chartWrapper': {
            height: '350px',
            width: '100%',
        },

        '& .chartWrapper2': {
            height: '450px',
            width: '100%',
        },

        '& .title': {
            textAlign: 'left',
        }

    },
    divTable: {
        width: '100%',
        maxWidth: '100%',
        justifyContent: 'center',

        '& .title': {
            textAlign: 'left',
        }

    },
    loadTop: {
        marginRight: '10px',
        height: '15px !important',
        width: '15px !important',
        color: unoTheme.mainColor,
    },

    tableBlade: {
        tableLayout: 'fixed',

        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                fontSize: '12px',
                padding: '4px 4px',
                fontWeight: "bold",
                color: '#1C2228',
                wordWrap: 'break-word',
            },

            '& .MuiTableCell-root:first-child': {
                paddingLeft: '16px',
                borderRight: 'solid 1.5px #E4E7EB'
            },
            '& > *': {
                borderBottom: 'unset',
            },
        },

        '& .MuiTableBody-root': {
            '& .MuiTableRow-root': {
                borderRadius: '10px',
                '&:nth-of-type(odd)': {
                    backgroundColor: unoTheme.secondaryTuplaTable,
                },

                '&:nth-of-type(even)': {
                    backgroundColor: 'white',
                },

                '& > *': {
                    borderBottom: 'unset',
                },
            },

            '& .MuiTableCell-root': {
                fontSize: '12px',
                padding: '12px 4px',
                color: 'black',
            },

            '& .MuiTableCell-root:first-child': {
                borderRight: 'solid 1.5px #E4E7EB',
                paddingLeft: '16px',
                borderTopLeftRadius: '10px',
                borderBottomLeftRadius: '10px',
            },

            '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
            },

            '& .MuiTableRow-root.benchmarkRow': {
                backgroundColor: unoTheme.mainColor + ' !important',
                '& .MuiTableCell-root': {
                    color: 'white !important',
                }
            },
        },
    },
    returnsTableContainer: {
        overflowX: 'auto',
        marginBottom: theme.spacing(3),
    },
    ellipsis: {
        whiteSpace: "nowrap", /* Impede a quebra de linha */
        overflow: "hidden", /* Garante que o texto extra seja ocultado */
        textOverflow: "ellipsis",
    },
}));

export default function CompareFundsScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const [allFunds, setAllFunds] = useState(null);
    const [fundSelectedToCompare, setFundSelectedToCompare] = useState(null);
    const [fundsInCompare, setFundsInCompare] = useState([]);
    const [mapCnpjsFunds, setMapCnpjsFunds] = useState(null);

    const [allBenchmarks, setAllBenchmarks] = useState(null);
    const [benchmarkSelectedToCompare, setBenchmarkSelectedToCompare] = useState(null);
    const [benchamrksInCompare, setBenchamrksInCompare] = useState([]);

    //Predefinições
    const [allPresets, setAllPresets] = useState([]);
    const [presetSelected, setPresetSelected] = useState(null);
    const [openPresetModal, setOpenPresetModal] = useState(false);
    const [presetTitleInput, setPresetTitleInput] = useState("");
    const [submittedPreset, setSubmittedPreset] = useState(false);
    const [allFundsGroups, setAllFundsGroups] = useState([]);
    const [presetGroupInput, setPresetGroupInput] = useState(null);
    //false: todos os fundos da base enquadrados no agrupamento | true: somente os da carteira do cliente
    const [presetOnlyClientFundsInput, setPresetOnlyClientFundsInput] = useState(false);
    const [loadingPresetGroup, setLoadingPresetGroup] = useState(false);

    //Somente clientes liberados em Agrupamentos de Fundos > Clientes cadastram predefinições atreladas a agrupamento
    const [canManageGroupPresets, setCanManageGroupPresets] = useState(false);
    const [reportMenuAnchor, setReportMenuAnchor] = useState(null);

    //Charts
    const [typesChart, setTypesChart] = useState(['Valores mensais', 'Valores acumulados']);
    const [typeChartSelected, setTypeChartSelected] = useState(0);
    const handleChangeTypeChartPeriod = (value) => {

        setTypeChartSelected(value);
        formatDataToRentsChart(mapCnpjsFunds, allRentsFundsData, periodRentsSelected, parseInt(value));

    };
    const [loadPatrimonyChart, setLoadPatrimonyChart] = useState(false);
    const [periods, setPeriods] = useState(['12 meses', '24 meses', '36 meses', '48 meses', '60 meses']);
    const [allPatrimonyData, setAllPatrimonyData] = useState([]);
    const [periodChartPatrimonioSelected, setPeriodChartPatrimonioSelected] = useState(null);
    const handleChangeChartPatrimonioPeriod = (value) => {

        setPeriodChartPatrimonioSelected(value);
        formatDataToPatrimonyChart(mapCnpjsFunds, allPatrimonyData.byMonth, parseInt(value));

    };

    const [loadRiskAndReturnTable, setLoadRiskAndReturnTable] = useState(false);
    const [allRiskReturnData, setAllRiskReturnData] = useState([]);

    const [loadRentsFundsChart, setLoadloadRentsFundsChart] = useState(false);
    const [allRentsFundsData, setAllRentsFundsData] = useState([]);

    const [dataPatrimonyChart, setDataPatrimonyChart] = useState();
    const [dataRentsChart, setDataRentsChart] = useState();

    const [periodRentsSelected, setPeriodRentsSelected] = useState(null);
    const handleChangeChartRentsPeriod = (value) => {

        setPeriodRentsSelected(value);
        formatDataToRentsChart(mapCnpjsFunds, allRentsFundsData, parseInt(value), typeChartSelected);

    };

    // Nova state para tabela de retornos
    const [returnsTableData, setReturnsTableData] = useState([]);
    const [monthLabels, setMonthLabels] = useState([]);
    const [yearLabels, setYearLabels] = useState([]);
    //END CHARTS

    const fundsInCompareDivRef = useRef(null)

    const [inCompare, setInCompare] = useState(false);

    async function doGetAllFunds() {
        const responseAllFunds = await FundAPI.getAllFunds();

        if (responseAllFunds.success) {
            setAllFunds(responseAllFunds.body.rows)
        }
    }

    async function doGetAllBenchmarks() {
        const response = await LocalBenchMarksAPI.getLocalBenchmarks();
        if (response.success) {

            setAllBenchmarks(response.body.rows);

        }
    }

    async function doGetPresets() {
        if (!clientOn || !clientOn.client || !clientOn.client.id) return;
        const resp = await ClientAPI.listCompareFundsPresets(clientOn.client.id);
        if (resp.success) {
            setAllPresets(resp.body.rows || []);
        }
    }

    async function doGetFundsGroups() {
        const resp = await FundGroupsAPI.getFundGroups();
        if (resp.success) {
            setAllFundsGroups(resp.body.rows || []);
        }
    }

    async function doCheckGroupPresetsEnabled() {
        setCanManageGroupPresets(false);
        if (!clientOn || !clientOn.client || !clientOn.client.id) return;
        const resp = await FundGroupsAPI.isClientEnabledForFundGroups(clientOn.client.id);
        if (resp.success && resp.body) {
            setCanManageGroupPresets(resp.body.enabled === true);
        }
    }

    function presetNameExists(name) {
        if (!name) return false;
        return allPresets.some(p => p.title.trim().toLowerCase() === name.trim().toLowerCase());
    }

    function sameIdSet(a, b) {
        if (a.length !== b.length) return false;
        const setB = new Set(b);
        return a.every(id => setB.has(id));
    }

    //Retorna true se a seleção atual for idêntica ao preset (nada foi alterado desde a carga)
    function selectionMatchesPreset(preset) {
        if (!preset) return false;

        //Considera apenas ids que ainda existem, para bater com o que loadPreset carrega
        const presetFundIds = (preset.funds_json || []).filter(id => allFunds && allFunds.some(f => f.id === id));
        const presetBenchIds = (preset.benchmarks_json || []).filter(id => allBenchmarks && allBenchmarks.some(b => b.id === id));

        const currentFundIds = fundsInCompare.map(f => f.id);
        const currentBenchIds = benchamrksInCompare.map(b => b.id);

        return sameIdSet(presetFundIds, currentFundIds) && sameIdSet(presetBenchIds, currentBenchIds);
    }

    //Só mostra "+ Predef." com 2+ entidades e se não estiver exatamente igual ao preset selecionado
    function canShowSavePresetButton() {
        if ((fundsInCompare.length + benchamrksInCompare.length) < 2) return false;
        if (presetSelected && selectionMatchesPreset(presetSelected)) return false;
        return true;
    }

    async function doSavePreset() {

        setSubmittedPreset(true);

        if (!presetTitleInput || presetTitleInput.trim() === "" || presetNameExists(presetTitleInput)) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: presetNameExists(presetTitleInput) ? 'Já existe predefinição com esse nome' : 'Insira o título da predefinição',
                type: 'warning'
            }))
            return;
        }

        const fundsIds = fundsInCompare.map(f => f.id);
        const benchmarksIds = benchamrksInCompare.map(b => b.id);
        const fundGroupId = presetGroupInput ? presetGroupInput.id : null;

        //Um preset precisa ter um agrupamento OU ao menos uma entidade selecionada
        if (!fundGroupId && fundsIds.length === 0 && benchmarksIds.length === 0) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Selecione fundos/benchmarks ou um agrupamento',
                type: 'warning'
            }))
            return;
        }

        const resp = await ClientAPI.saveCompareFundsPreset(clientOn.client.id, presetTitleInput.trim(), fundsIds, benchmarksIds, fundGroupId,
            fundGroupId ? presetOnlyClientFundsInput : false);

        if (resp.success && resp.body && resp.body.exists) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Já existe predefinição com esse nome',
                type: 'warning'
            }))
            return;
        }

        if (resp.success && resp.body && resp.body.groupExists) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Este agrupamento já está relacionado a uma predefinição',
                type: 'warning'
            }))
            return;
        }

        if (resp.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Predefinição cadastrada com sucesso',
                type: 'success'
            }))
            setOpenPresetModal(false);
            setPresetTitleInput("");
            setPresetGroupInput(null);
            setPresetOnlyClientFundsInput(false);
            setSubmittedPreset(false);
            doGetPresets();
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: resp.body && resp.body.message ? resp.body.message : 'Falha ao cadastrar predefinição',
                type: 'error'
            }))
        }
    }

    async function loadPreset(preset) {
        if (!preset) return;

        const benchmarksIds = preset.benchmarks_json || [];
        const benchmarks = benchmarksIds.map(id => allBenchmarks && allBenchmarks.find(b => b.id === id)).filter(Boolean);

        let funds;

        if (preset.fund_group_id) {

            //Preset de agrupamento: resolve os fundos dinamicamente pelos artigos do grupo
            //Quando only_client_funds, restringe aos fundos com saldo na carteira do mês/ano selecionado
            //(os totalmente resgatados ficam de fora)
            const onlyClientFunds = preset.only_client_funds === true;
            const portfolioMonth = clientOn && clientOn.client ? clientOn.client.selectedPortfolioMonth : null;
            const portfolioYear = clientOn && clientOn.client ? clientOn.client.selectedPortfolioYear : null;

            let groupFundIds = [];

            //Cliente sem carteira: no modo carteira não há fundos a carregar
            if (!onlyClientFunds || (portfolioMonth && portfolioYear)) {

                setLoadingPresetGroup(true);
                const resp = await FundGroupsAPI.getFundGroupFunds(preset.fund_group_id,
                    onlyClientFunds && clientOn && clientOn.client ? clientOn.client.id : null,
                    onlyClientFunds ? portfolioMonth : null,
                    onlyClientFunds ? portfolioYear : null);
                setLoadingPresetGroup(false);

                groupFundIds = resp.success && resp.body.rows ? resp.body.rows.map(r => r.id) : [];
            }

            //Predefinição de agrupamento não tem limite de fundos
            funds = groupFundIds.map(id => allFunds && allFunds.find(f => f.id === id)).filter(Boolean);

            if (!funds.length) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: onlyClientFunds
                        ? (portfolioMonth && portfolioYear
                            ? 'Nenhum fundo da carteira de ' + String(portfolioMonth).padStart(2, '0') + '/' + portfolioYear
                            + ' enquadrado nos artigos deste agrupamento'
                            : 'Cliente sem carteira para carregar os fundos deste agrupamento')
                        : 'Nenhum fundo enquadrado atualmente nos artigos deste agrupamento',
                    type: 'warning'
                }))
            }

        } else {

            const fundsIds = preset.funds_json || [];
            funds = fundsIds.map(id => allFunds && allFunds.find(f => f.id === id)).filter(Boolean);
        }

        setFundsInCompare(funds);
        setBenchamrksInCompare(benchmarks);
        setInCompare(false);
        setPresetSelected(preset);
    }

    async function doDeletePreset(preset) {
        if (!preset) return;

        const resp = await ClientAPI.deleteCompareFundsPreset(preset.id);

        if (resp.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Predefinição excluída com sucesso',
                type: 'success'
            }))
            if (presetSelected && presetSelected.id === preset.id) {
                setPresetSelected(null);
            }
            doGetPresets();
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: 'Falha ao excluir predefinição',
                type: 'error'
            }))
        }
    }

    function addFundToCompare(fundToCompare) {


        if (fundToCompare && !fundsInCompare.some(el => el.id == fundToCompare.id)) {
            if (fundsInCompare.length < maxFundsInCompare) {

                setInCompare(false);

                const newFundsToCompare = [...fundsInCompare];
                newFundsToCompare.push(fundToCompare);
                setFundsInCompare(newFundsToCompare);

            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Número máximo de fundos atingidos',
                    type: 'warning'
                }))
            }
        } else {
            if (fundToCompare) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Fundo já selecionado',
                    type: 'warning'
                }))
            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Selecione um fundo',
                    type: 'warning'
                }))
            }

        }



    }

    function removeFundToCompare(index) {

        setInCompare(false);

        fundsInCompare.splice(index, 1)
        const newFundsToCompare = [...fundsInCompare];
        setFundsInCompare(newFundsToCompare);


    }

    function addBenchmarkToCompare(becnhmarkToCompare) {

        if (becnhmarkToCompare && !benchamrksInCompare.some(el => el.id == becnhmarkToCompare.id)) {
            if (benchamrksInCompare.length < 5) {

                setInCompare(false);

                const newBenchmarksToCompare = [...benchamrksInCompare];
                newBenchmarksToCompare.push(becnhmarkToCompare);
                setBenchamrksInCompare(newBenchmarksToCompare);
            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Número máximo de benchmarks atingidos',
                    type: 'warning'
                }))
            }
        } else {
            if (becnhmarkToCompare) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Benchmark já selecionado',
                    type: 'warning'
                }))
            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: 'Selecione um benchmark',
                    type: 'warning'
                }))
            }

        }



    }

    function removeBenchmarkToCompare(index) {

        setInCompare(false);

        benchamrksInCompare.splice(index, 1)
        const newBenchmarksToCompare = [...benchamrksInCompare];
        setBenchamrksInCompare(newBenchmarksToCompare);

    }

    function renderFundsInCompare(funds) {


        const layoutGridFundsInCompare = [];
        funds.forEach((element, index) => {
            layoutGridFundsInCompare.push(
                <Grid className="fundInCompare" item key={'fund-in-compare-' + index} md={12} sm={12} lg={12}>
                    <Paper className={'cardFund'} elevation={3}>
                        <div className={'cardFundTop'}>

                            <p className="segment" style={{ color: unoTheme.chartColorsCompareFunds[element.legislation_segment_id] }}>{element.segment}</p>
                            <p className="removeFund" onClick={() => removeFundToCompare(index)}><Remove /></p>
                        </div>
                        <p className="fundName">{element.fund_name}</p>
                        <p className="cnpj">{element.cnpj}</p>
                    </Paper>
                </Grid>
            )
        });

        return layoutGridFundsInCompare;

    }

    function renderBenchmarksInCompare(benchmarks) {

        const layoutGridBenchmarksInCompare = [];
        benchmarks.forEach((element, index) => {
            layoutGridBenchmarksInCompare.push(
                <Grid className="fundInCompare" item key={'fund-in-compare-' + index} md={12} sm={12} lg={12}>
                    <Paper className={'cardFund'} elevation={3}>
                        <div className={'cardFundTop'}>

                            <p className="segment" style={{ color: unoTheme.chartColorsCompareFunds[16] }}>Benchmark</p>
                            <p className="removeFund" onClick={() => removeBenchmarkToCompare(index)}><Remove /></p>
                        </div>
                        <p className="fundName">{element.name}</p>
                        <p className="cnpj">{ }</p>
                    </Paper>
                </Grid>
            )
        });

        return layoutGridBenchmarksInCompare;

    }

    function changeComdinheiroBenchmarkToLocalBenchmark(riskReturnMap) {
        const newRiskReturnMap = {};

        Object.entries(riskReturnMap || {}).forEach(([key, row]) => {
            if (key === "  CNPJ do Fundo") return;
            if (isValidCnpj(key)) {
                newRiskReturnMap[key] = row;
                return;
            }

            const localBenchmarkFound = allBenchmarks.find(
                (el) => String(el.comdinheiro_name || "").toUpperCase() === String(key).toUpperCase()
            );

            if (localBenchmarkFound) {
                newRiskReturnMap[localBenchmarkFound.name] = {
                    ...row,
                    fund_name: localBenchmarkFound.name,
                };
            } else {
                newRiskReturnMap[key] = row;
            }
        });

        return newRiskReturnMap;
    }

    // Função para calcular retornos acumulados
    function calculateAccumulatedReturns(returnsArray) {
        if (!returnsArray || returnsArray.length === 0) return null;

        let accumulated = 1;
        returnsArray.forEach(ret => {
            if (ret !== null && ret !== undefined) {
                accumulated *= (1 + ret / 100);
            }
        });
        return (accumulated - 1) * 100;
    }

    // Função para formatar percentual
    function formatPercent(value) {
        if (value === null || value === undefined || isNaN(value)) {
            return '-';
        }
        //return value.toFixed(2).replace('.', ',') + '%';
        return value.toFixed(2).replace('.', ',');
    }

    // Função para formatar data no formato MM/AA
    function formatMonthYear(dateStr) {
        if (!dateStr) return '';
        const [month, year] = dateStr.split('/');
        // Pegar apenas os últimos 2 dígitos do ano
        const shortYear = year.length > 2 ? year.slice(-2) : year;
        return `${month.padStart(2, '0')}/${shortYear}`;
    }

    // Função para obter anos completos disponíveis
    function getCompleteYears(rentsData) {
        if (!rentsData || rentsData.length === 0) return [];

        const yearsMap = {};
        rentsData.forEach(month => {
            const [monthStr, yearStr] = month.data.split('/');
            const year = parseInt(yearStr);
            if (!yearsMap[year]) {
                yearsMap[year] = [];
            }
            yearsMap[year].push(month);
        });

        // Ordenar anos do mais recente para o mais antigo
        const sortedYears = Object.keys(yearsMap)
            .map(year => parseInt(year))
            .sort((a, b) => b - a);

        // Pegar os dois anos mais recentes que têm dados completos
        const currentYear = new Date().getFullYear();
        const completeYears = sortedYears.filter(year => year < currentYear).slice(0, 2);

        return completeYears;
    }

    // Função para calcular retorno anual
    function calculateYearReturn(rentsData, year, cnpj) {
        const yearData = rentsData.filter(month => {
            const [monthStr, yearStr] = month.data.split('/');
            return parseInt(yearStr) === year;
        });

        const yearReturns = yearData.map(month => month[cnpj]);
        return calculateAccumulatedReturns(yearReturns);
    }

    // Função para processar dados da tabela de retornos
    function processReturnsTableData(rentsData, funds, benchmarks, mapFunds) {
        if (!rentsData || rentsData.length === 0) return { tableData: [], monthLabels: [], yearLabels: [] };

        const tableData = [];

        // Obter anos completos disponíveis
        const completeYears = getCompleteYears(rentsData);

        // Pegar os últimos 12 meses completos (incluindo setembro)
        const last12MonthsData = rentsData.slice(-12); // Últimos 12 meses, mais recente primeiro

        // Gerar labels dos meses no formato MM/AA
        const monthLabels = last12MonthsData.map(month => formatMonthYear(month.data));

        // Processar fundos
        funds.forEach(fund => {
            const fundData = {
                name: fund.fund_name,
                isBenchmark: false,
                returns: {
                    // Adicionar retornos anuais
                    years: {},
                    months12: null,
                    months24: null,
                    months36: null,
                    months48: null,
                    months60: null,
                    monthly: []
                }
            };

            const fundReturns = rentsData.map(month => month[fund.cnpj]);

            // Calcular retornos anuais para cada ano completo
            completeYears.forEach(year => {
                fundData.returns.years[year] = calculateYearReturn(rentsData, year, fund.cnpj);
            });

            // Calcular retornos acumulados
            // 12 meses
            const returns12m = rentsData.slice(-12).map(month => month[fund.cnpj]);
            fundData.returns.months12 = calculateAccumulatedReturns(returns12m);

            // 24 meses
            const returns24m = rentsData.slice(-24).map(month => month[fund.cnpj]);
            fundData.returns.months24 = calculateAccumulatedReturns(returns24m);

            // 36 meses
            const returns36m = rentsData.slice(-36).map(month => month[fund.cnpj]);
            fundData.returns.months36 = calculateAccumulatedReturns(returns36m);

            // 48 meses
            const returns48m = rentsData.slice(-48).map(month => month[fund.cnpj]);
            fundData.returns.months48 = calculateAccumulatedReturns(returns48m);

            // 60 meses
            const returns60m = rentsData.slice(-60).map(month => month[fund.cnpj]);
            fundData.returns.months60 = calculateAccumulatedReturns(returns60m);

            // Retornos mensais (últimos 12 meses)
            fundData.returns.monthly = last12MonthsData.map(month => month[fund.cnpj]);

            tableData.push(fundData);
        });

        // Processar benchmarks
        benchmarks.forEach(benchmark => {
            const benchData = {
                name: benchmark.name,
                isBenchmark: true,
                returns: {
                    years: {},
                    months12: null,
                    months24: null,
                    months36: null,
                    months48: null,
                    months60: null,
                    monthly: []
                }
            };

            // Calcular retornos anuais para cada ano completo
            completeYears.forEach(year => {
                benchData.returns.years[year] = calculateYearReturn(rentsData, year, benchmark.comdinheiro_name);
            });

            // 12 meses
            const returns12m = rentsData.slice(-12).map(month => month[benchmark.comdinheiro_name]);
            benchData.returns.months12 = calculateAccumulatedReturns(returns12m);

            // 24 meses
            const returns24m = rentsData.slice(-24).map(month => month[benchmark.comdinheiro_name]);
            benchData.returns.months24 = calculateAccumulatedReturns(returns24m);

            // 36 meses
            const returns36m = rentsData.slice(-36).map(month => month[benchmark.comdinheiro_name]);
            benchData.returns.months36 = calculateAccumulatedReturns(returns36m);

            // 48 meses
            const returns48m = rentsData.slice(-48).map(month => month[benchmark.comdinheiro_name]);
            benchData.returns.months48 = calculateAccumulatedReturns(returns48m);

            // 60 meses
            const returns60m = rentsData.slice(-60).map(month => month[benchmark.comdinheiro_name]);
            benchData.returns.months60 = calculateAccumulatedReturns(returns60m);

            // Retornos mensais
            benchData.returns.monthly = last12MonthsData.map(month => month[benchmark.comdinheiro_name]);

            tableData.push(benchData);
        });

        return { tableData, monthLabels, yearLabels: completeYears };
    }

    async function doCompareOld(funds, benchmarks) {
        setInCompare(true);
        setDataRentsChart(null);
        setDataPatrimonyChart(null);
        setPeriodChartPatrimonioSelected(0);
        setPeriodRentsSelected(0);
        setReturnsTableData([]);
        setMonthLabels([]);
        setYearLabels([]);

        const cnpjs = [];
        const codesToComdinheiro = [];
        const mapFundsByCnpj = {};

        //Obtendo data de 36 meses atrás
        const endDate = getReferenceDate();
        const startDate = getDayMonthsAgo(endDate, 37);
        const { month, year } = getDayMonthYearByPtDate(endDate);

        funds.forEach((element, idx) => {
            const code = getCodeToComdinheiroQuotas(element, month, year);
            cnpjs.push(element.cnpj);
            codesToComdinheiro.push(code);
            mapFundsByCnpj[element.cnpj] = element;
        });

        setMapCnpjsFunds(mapFundsByCnpj);
        setLoadPatrimonyChart(true);
        setLoadRiskAndReturnTable(true);
        setLoadloadRentsFundsChart(true);

        let responseRents;
        try {
            responseRents = await ComDinheiroAPI.getHistoricoRentabilidadesPorPeriodo(
                cnpjs,
                benchmarks,
                startDate,
                endDate
            );
        } catch (err) {
            responseRents = null;
        }

        if (responseRents) {
            setAllRentsFundsData(responseRents.body);
            setLoadloadRentsFundsChart(false);

            try {
                formatDataToRentsChart(mapFundsByCnpj, responseRents.body, 0, 0);
            } catch (err) {
            }

            try {
                const { tableData, monthLabels, yearLabels } = processReturnsTableData(
                    responseRents.body,
                    funds,
                    benchmarks,
                    mapFundsByCnpj
                );

                setReturnsTableData(tableData);
                setMonthLabels(monthLabels);
                setYearLabels(yearLabels);
            } catch (err) {
                setReturnsTableData([]);
                setMonthLabels([]);
                setYearLabels([]);
            }
        } else {
            setAllRentsFundsData(null);
            setLoadloadRentsFundsChart(false);
        }

        let responsePatrimony;

        try {
            responsePatrimony = await ComDinheiroAPI.getTablePatrimonioComdinheiroByPeriod(
                startDate,
                endDate,
                cnpjs,
                benchmarks,
                REQ_COMDINHEIRO_TYPE.COMPARADOR_FUNDOS
            );
        } catch (err) {
            responsePatrimony = null;
        }

        if (responsePatrimony?.body) {
            setAllPatrimonyData(responsePatrimony.body);
        } else {
            setAllPatrimonyData(null);
        }

        setLoadPatrimonyChart(false);

        formatDataToPatrimonyChart(mapFundsByCnpj, responsePatrimony?.body?.byMonth, 0);

        let responseRiskReturn;
        try {
            responseRiskReturn = await ComDinheiroAPI.getInfosAndRiskFundComdinheiroByMultiPeriods(
                endDate,
                codesToComdinheiro,
                benchmarks,
                REQ_COMDINHEIRO_TYPE.COMPARADOR_FUNDOS
            );

        } catch (err) {
            console.log("Errr: ", err);
            responseRiskReturn = null;
        }

        try {
            const changed = changeComdinheiroBenchmarkToLocalBenchmark(
                responseRiskReturn.body,
                mapFundsByCnpj
            );

            setAllRiskReturnData(changed);

        } catch (err) {
            setAllRiskReturnData(null);
        }

        setLoadRiskAndReturnTable(false);
    }

    async function doCompare(funds, benchmarks) {
        setInCompare(true);
        setDataRentsChart(null);
        setDataPatrimonyChart(null);
        setPeriodChartPatrimonioSelected(0);
        setPeriodRentsSelected(0);
        setReturnsTableData([]);
        setMonthLabels([]);
        setYearLabels([]);

        const cnpjs = [];
        const codesToComdinheiro = [];
        const mapFundsByCnpj = {};

        //Obtendo data de 60 meses atrás para suportar os períodos disponíveis
        const endDate = getReferenceDate();
        const startDate = getDayMonthsAgo(endDate, 61);
        const { month, year } = getDayMonthYearByPtDate(endDate);

        funds.forEach((element, idx) => {
            const code = getCodeToComdinheiroQuotas(element, month, year);
            cnpjs.push(element.cnpj);
            codesToComdinheiro.push(code);
            mapFundsByCnpj[element.cnpj] = element;
        });

        setMapCnpjsFunds(mapFundsByCnpj);
        setLoadPatrimonyChart(true);
        setLoadRiskAndReturnTable(true);
        setLoadloadRentsFundsChart(true);

        let responseHistorico;
        let responseRiskReturn;

        try {
            [responseHistorico, responseRiskReturn] = await Promise.all([
                ComDinheiroAPI.getHistoricoRentabilidadesEPatrimonioPorPeriodo(
                    cnpjs,
                    benchmarks,
                    startDate,
                    endDate
                ),
                ComDinheiroAPI.getInfosAndRiskFundComdinheiroAllPeriodsSingle(
                    endDate,
                    codesToComdinheiro,
                    benchmarks,
                    REQ_COMDINHEIRO_TYPE.COMPARADOR_FUNDOS
                ),
            ]);
        } catch (err) {
            console.log("doCompare parallel calls error: ", err);
            responseHistorico = null;
            responseRiskReturn = null;
        }

        const responseRents = responseHistorico?.body?.rents ? { body: responseHistorico.body.rents } : null;
        const responsePatrimony = responseHistorico?.body?.patrimony ? { body: responseHistorico.body.patrimony } : null;

        if (responseRents) {
            setAllRentsFundsData(responseRents.body);
            setLoadloadRentsFundsChart(false);

            try {
                formatDataToRentsChart(mapFundsByCnpj, responseRents.body, 0, 0);
            } catch (err) {
            }

            try {
                const { tableData, monthLabels, yearLabels } = processReturnsTableData(
                    responseRents.body,
                    funds,
                    benchmarks,
                    mapFundsByCnpj
                );

                setReturnsTableData(tableData);
                setMonthLabels(monthLabels);
                setYearLabels(yearLabels);
            } catch (err) {
                setReturnsTableData([]);
                setMonthLabels([]);
                setYearLabels([]);
            }
        } else {
            setAllRentsFundsData(null);
            setLoadloadRentsFundsChart(false);
        }

        if (responsePatrimony?.body) {
            setAllPatrimonyData(responsePatrimony.body);
        } else {
            setAllPatrimonyData(null);
        }

        setLoadPatrimonyChart(false);

        formatDataToPatrimonyChart(mapFundsByCnpj, responsePatrimony?.body?.byMonth, 0);

        try {
            const changed = changeComdinheiroBenchmarkToLocalBenchmark(
                responseRiskReturn.body,
                mapFundsByCnpj
            );

            setAllRiskReturnData(changed);

        } catch (err) {
            setAllRiskReturnData(null);
        }

        setLoadRiskAndReturnTable(false);
    }


    function getDataPatrimonioChart(fundsValues, labels, mapFunds) {

        console.log('mapCnpjsFunds: ', mapCnpjsFunds);

        const datasets = [];

        let index = 0;
        Object.entries(fundsValues).map(([key, values]) => {
            datasets.push(
                {
                    label: mapFunds ? mapFunds[key].fund_name : key,
                    fill: false,
                    backgroundColor: unoTheme.chartColorsCompareFunds[index],
                    borderColor: unoTheme.chartColorsCompareFunds[index],
                    pointBackgroundColor: unoTheme.chartColorsCompareFunds[index],
                    pointBorderColor: unoTheme.chartColorsCompareFunds[index],
                    pointHoverBackgroundColor: unoTheme.chartColorsCompareFunds[index],
                    pointHoverBorderColor: unoTheme.chartColorsCompareFunds[index],
                    data: values,
                    type: 'line',
                },
            )
            index++;
        })

        console.log('datasets: ', datasets);

        let dataChartPatrimonio = {
            labels: labels,
            datasets: datasets,
        };

        return dataChartPatrimonio;
    }

    function getDataRentsChart(fundsValues, labels, mapFunds) {
        console.log('fundsValues: ', fundsValues);

        const datasets = [];

        // índices separados pra não bagunçar a paleta dos fundos quando adicionar benchmarks
        let fundColorIndex = 0;
        let benchColorIndex = 0;

        const fundColors = unoTheme.chartColorsCompareFunds || [];
        const benchColors = unoTheme.chartColorsBenchmark || [];

        Object.entries(fundsValues).forEach(([key, values]) => {
            if (key === '  CNPJ do Fundo') return;

            if (isValidCnpj(key)) {
                // FUNDO = linha, cor por fundo
                const color =
                    fundColors.length > 0
                        ? fundColors[fundColorIndex % fundColors.length]
                        : '#2749F1';

                fundColorIndex++;

                datasets.push({
                    label: mapFunds && mapFunds[key] ? mapFunds[key].fund_name : key,
                    fill: false,
                    backgroundColor: color,
                    borderColor: color,
                    pointBackgroundColor: color,
                    pointBorderColor: color,
                    pointHoverBackgroundColor: color,
                    pointHoverBorderColor: color,
                    data: values,
                    type: 'line',
                });
            } else {
                // BENCHMARK = barra, cor por benchmark
                const color =
                    benchColors.length > 0
                        ? benchColors[benchColorIndex % benchColors.length]
                        : (fundColors.length > 0
                            ? fundColors[benchColorIndex % fundColors.length]
                            : '#111827');

                benchColorIndex++;

                datasets.push({
                    label: mapFunds && mapFunds[key] ? mapFunds[key].fund_name : key,
                    backgroundColor: color,
                    borderColor: color,
                    data: values,
                    type: 'bar',
                });
            }
        });

        return {
            labels,
            datasets,
        };
    }

    function getDataPatrimonyChartByPeriod(data, period) {
        //Inicializando select de chart year
        let dataChartPatrimonio = [];
        let labels = [];

        //O período pode ser 0, 1, 2, 3 ou 4, correspondendo a 12, 24, 36, 48 ou 60 meses
        let resultPeriod = ((period + 1) * 12);
        console.log("Result period: ", resultPeriod);
        let dataSlice = data.slice(Math.max(0, data.length - resultPeriod))
        console.log("FORMAT DATA: ", dataSlice);

        const valuesToPatrimonyChart = {};
        const cnpjs = [];
        fundsInCompare.forEach(fundInCompare => {

            cnpjs.push(fundInCompare.cnpj);
            valuesToPatrimonyChart[fundInCompare.cnpj] = [];
        });

        //Fazendo o slice com o período 12, 24, 36                       

        dataSlice.forEach(value => {

            cnpjs.forEach(cnpj => {
                valuesToPatrimonyChart[cnpj].push({
                    y: value[cnpj]
                })
            });

            labels.push(value.data);
        });

        return {
            valuesToPatrimonyChart: valuesToPatrimonyChart,
            labels: labels,
        }
    }

    function formatDataToPatrimonyChart(mapFunds, data, period) {

        console.log("DATA PATRIMONIO: ", data);

        const { valuesToPatrimonyChart, labels } = getDataPatrimonyChartByPeriod(data.slice(1), period);

        setDataPatrimonyChart(getDataPatrimonioChart(valuesToPatrimonyChart, labels, mapFunds));

    }

    function getDataRentsChartByTypeAndPeriod(data, period, typeChart) {
        const labels = [];
        const valuesToRentsChart = {};
        const cnpjs = [];
        fundsInCompare.forEach(fundInCompare => {

            cnpjs.push(fundInCompare.cnpj);
            valuesToRentsChart[fundInCompare.cnpj] = [];
        });

        benchamrksInCompare.forEach(benchInCompare => {

            cnpjs.push(benchInCompare.comdinheiro_name);
            valuesToRentsChart[benchInCompare.comdinheiro_name] = [];
        });

        //O período pode ser 0, 1, 2, 3 ou 4, correspondendo a 12, 24, 36, 48 ou 60 meses
        let resultPeriod = ((period + 1) * 12);
        console.log("Result period rents: ", resultPeriod);
        let dataSlice = data.slice(Math.max(0, data.length - resultPeriod))
        console.log("FORMAT DATA rents: ", dataSlice);

        console.log('cnpjs: ', cnpjs);
        console.log('valuesToRentsChart: ', valuesToRentsChart);

        //Inicializando variável para valor acumulado
        const acumValueToCnpj = {};
        cnpjs.forEach(cnpj => {

            acumValueToCnpj[cnpj] = 1;

        });

        dataSlice.forEach(value => {

            if (typeChart == 0) { //retornos mensais

                cnpjs.forEach(cnpj => {
                    valuesToRentsChart[cnpj].push({
                        y: value[cnpj]
                    })
                });

            } else { //valores acumulados

                cnpjs.forEach(cnpj => {

                    acumValueToCnpj[cnpj] *= (1 + (value[cnpj] / 100));

                    valuesToRentsChart[cnpj].push({
                        y: parseFloat(parseFloat((acumValueToCnpj[cnpj] - 1) * 100).toFixed(2))
                    })

                });
            }

            labels.push(value.data);


        });


        const newValuesToRentsChart = {};
        Object.entries(valuesToRentsChart).map(([key, row]) => {
            if (key != '  CNPJ do Fundo') {

                if (!isValidCnpj(key)) {

                    const localBenchmarkFound = allBenchmarks.find(el => el.comdinheiro_name.toUpperCase() == key.toUpperCase());

                    if (localBenchmarkFound) {

                        newValuesToRentsChart[localBenchmarkFound.name] = row;
                    } else {

                        newValuesToRentsChart[key] = row;

                    }

                } else {

                    newValuesToRentsChart[key] = row;
                }
            }
        })

        return {
            valuesToRentsChart: newValuesToRentsChart, labels
        }
    }

    function formatDataToRentsChart(mapFunds, data, period, typeChart) {
        console.log("DATA RENTS: ", data);
        if (data) {

            const { valuesToRentsChart, labels } = getDataRentsChartByTypeAndPeriod(data.slice(1), period, typeChart);

            setDataRentsChart(getDataRentsChart(valuesToRentsChart, labels, mapFunds));
        }

    }

    function renderRowsVolatility(data, periods = ["12", "24", "36", "48", "60"]) {
        const rows = [];
        Object.entries(data || {}).forEach(([key, row]) => {
            const isBenchmark = !isValidCnpj(key);
            const label =
                mapCnpjsFunds?.[key]?.fund_name
                    ? mapCnpjsFunds[key].fund_name
                    : key.toUpperCase();

            rows.push(
                <TableRow
                    className={isBenchmark ? "benchmarkRow" : ""}
                    key={"compare-fund-risco-retorno-fund-" + key}
                >
                    <TableCell align="left">{label}</TableCell>

                    {periods.map((p) => {
                        const rr = row?.risco_retorno?.[p];

                        const vol = rr?.volatilidade;

                        return (
                            <TableCell key={`${key}-vol-${p}`} align="center">
                                {vol ? applyMaskAmountComdinheiro(vol) : "-"}
                            </TableCell>
                        );
                    })}
                </TableRow>
            );
        });

        return rows;
    }

    function renderRowsSharpe(data, periods = ["12", "24", "36", "48", "60"]) {
        const rows = [];
        Object.entries(data || {}).forEach(([key, row]) => {
            const isBenchmark = !isValidCnpj(key);
            const label =
                mapCnpjsFunds?.[key]?.fund_name
                    ? mapCnpjsFunds[key].fund_name
                    : key.toUpperCase();

            rows.push(
                <TableRow
                    className={isBenchmark ? "benchmarkRow" : ""}
                    key={"compare-fund-risco-retorno-fund-" + key}
                >
                    <TableCell align="left">{label}</TableCell>

                    {periods.map((p) => {
                        const rr = row?.risco_retorno?.[p];

                        const vol = rr?.indice_sharpe;

                        return (
                            <TableCell key={`${key}-vol-${p}`} align="center">
                                {vol ? applyMaskAmountComdinheiro(vol) : "-"}
                            </TableCell>
                        );
                    })}
                </TableRow>
            );
        });

        return rows;
    }

    function renderRowsReturn(data) {
        const rows = [];

        Object.entries(data || {}).forEach(([key, row]) => {
            const isBenchmark = !isValidCnpj(key);
            const label =
                mapCnpjsFunds?.[key]?.fund_name
                    ? mapCnpjsFunds[key].fund_name
                    : key.toUpperCase();

            const rr12 = row?.risco_retorno?.["12"] || row?.risco_retorno?.[12];

            const perdaMax = rr12?.perda_maxima;
            const retMax = rr12?.retorno_maximo;
            const retMin = rr12?.retorno_minimo;
            const retMed = rr12?.retorno_medio;

            rows.push(
                <TableRow
                    className={isBenchmark ? "benchmarkRow" : ""}
                    key={"compare-fund-return-12m-" + key}
                >
                    <TableCell align="left">{label}</TableCell>
                    <TableCell align="center">
                        {perdaMax ? applyMaskAmountComdinheiro(perdaMax) : "-"}
                    </TableCell>

                    <TableCell align="center">
                        {retMax ? applyMaskAmountComdinheiro(retMax) : "-"}
                    </TableCell>

                    <TableCell align="center">
                        {retMin ? applyMaskAmountComdinheiro(retMin) : "-"}
                    </TableCell>

                    <TableCell align="center">
                        {retMed ? applyMaskAmountComdinheiro(retMed) : "-"}
                    </TableCell>
                    <TableCell align="left"></TableCell>
                </TableRow>
            );
        });

        return rows;
    }

    function renderRowsQuotas(data) {
        const rows = [];

        Object.entries(data || {}).forEach(([key, row]) => {
            const isBenchmark = !isValidCnpj(key);
            const label =
                mapCnpjsFunds?.[key]?.fund_name
                    ? mapCnpjsFunds[key].fund_name
                    : key.toUpperCase();

            const rr12 = row?.risco_retorno?.["12"] || row?.risco_retorno?.[12];

            const cota = rr12?.cota;
            const pl = row?.dados_cadastrais?.pl_anbima;
            const cotistas = row?.dados_cadastrais?.num_cotistas;

            rows.push(
                <TableRow
                    className={isBenchmark ? "benchmarkRow" : ""}
                    key={"compare-fund-quotas-12m-" + key}
                >
                    <TableCell align="left">{label}</TableCell>

                    <TableCell align="center">
                        {cota ? applyMaskAmountComdinheiroFreeDecimals(cota) : "-"}
                    </TableCell>

                    <TableCell align="center">
                        {pl ? applyMaskAmountComdinheiro(pl) : "-"}
                    </TableCell>

                    <TableCell align="center">
                        {cotistas ? applyMaskAmountComdinheiro(cotistas) : "-"}
                    </TableCell>
                </TableRow>
            );
        });

        return rows;
    }

    // Função para renderizar as linhas da tabela de retornos
    function renderReturnsTableRows() {
        return returnsTableData.map((row, index) => (
            <TableRow
                key={`returns-table-row-${index}`}
                className={row.isBenchmark ? 'benchmarkRow' : ''}
            >
                <TableCell align="left" className={classes.ellipsis}>
                    <Tooltip className={classes.cursorPointer}
                        button title={row.name} enterDelay={100} leaveDelay={100} placement="left" arrow>
                        <span>{row.name}</span>
                    </Tooltip>
                </TableCell>
                {/* Colunas de anos */}
                {yearLabels.map(year => (
                    <TableCell key={`year-${year}`} align="center">
                        {formatPercent(row.returns.years[year])}
                    </TableCell>
                ))}
                <TableCell align="center">{formatPercent(row.returns.months12)}</TableCell>
                <TableCell align="center">{formatPercent(row.returns.months24)}</TableCell>
                <TableCell align="center">{formatPercent(row.returns.months36)}</TableCell>
                <TableCell align="center">{formatPercent(row.returns.months48)}</TableCell>
                <TableCell align="center">{formatPercent(row.returns.months60)}</TableCell>
                {row.returns.monthly.map((monthReturn, monthIndex) => (
                    <TableCell key={`month-${monthIndex}`} align="center">
                        {formatPercent(monthReturn)}
                    </TableCell>
                ))}
            </TableRow>
        ));
    }

    // Função para renderizar os headers dos meses
    function renderMonthHeaders() {
        return monthLabels.map((label, index) => (
            <TableCell key={`month-header-${index}`} align="center">
                {label}
            </TableCell>
        ));
    }

    // Função para renderizar os headers dos anos
    function renderYearHeaders() {
        return yearLabels.map(year => (
            <TableCell key={`year-header-${year}`} align="center">
                {year}
            </TableCell>
        ));
    }

    function pickPeriod(rrByPeriod, wanted) {
        if (!rrByPeriod) return null;
        return rrByPeriod[String(wanted)] || rrByPeriod[wanted] || null;
    }

    function pickWithFallback(rrByPeriod, wanted, fallback = 12) {
        return pickPeriod(rrByPeriod, wanted) || pickPeriod(rrByPeriod, fallback) || null;
    }

    function formatRiskReturnRowsToReport(rawMap, mapFundsByCnpj) {
        const rows = [];

        Object.entries(rawMap || {}).forEach(([key, asset]) => {
            const isBenchmark = !isValidCnpj(key);

            const fund_name = isBenchmark
                ? key.toUpperCase()
                : (mapFundsByCnpj?.[key]?.fund_name || key);

            const rr12 = pickWithFallback(asset?.risco_retorno, 12, 12) || {};
            const rr24 = pickWithFallback(asset?.risco_retorno, 24, 12) || {};
            const rr36 = pickWithFallback(asset?.risco_retorno, 36, 12) || {};
            const rr48 = pickWithFallback(asset?.risco_retorno, 48, 12) || {};
            const rr60 = pickWithFallback(asset?.risco_retorno, 60, 12) || {};

            rows.push({
                key,
                fund_name,
                isBenchmark,

                // tabela 1 (12m + cadastrais)
                cota_12: applyMaskAmountComdinheiroFreeDecimals(rr12.cota) || " - ",
                pl: applyMaskAmountComdinheiro(asset?.dados_cadastrais?.pl_anbima) ?? " - ",
                cotistas: applyMaskAmountComdinheiro(asset?.dados_cadastrais?.num_cotistas) ?? " - ",

                // tabela 2 (volatilidade 12/24/36/48/60)
                vol_12: applyMaskAmountComdinheiro(rr12.volatilidade) || " - ",
                vol_24: applyMaskAmountComdinheiro(rr24.volatilidade) || " - ",
                vol_36: applyMaskAmountComdinheiro(rr36.volatilidade) || " - ",
                vol_48: applyMaskAmountComdinheiro(rr48.volatilidade) || " - ",
                vol_60: applyMaskAmountComdinheiro(rr60.volatilidade) || " - ",

                // tabela 3 (sharpe 12/24/36/48/60)
                sharpe_12: applyMaskAmountComdinheiro(rr12.indice_sharpe) || " - ",
                sharpe_24: applyMaskAmountComdinheiro(rr24.indice_sharpe) || " - ",
                sharpe_36: applyMaskAmountComdinheiro(rr36.indice_sharpe) || " - ",
                sharpe_48: applyMaskAmountComdinheiro(rr48.indice_sharpe) || " - ",
                sharpe_60: applyMaskAmountComdinheiro(rr60.indice_sharpe) || " - ",

                // tabela 4 (12m)
                perda_max_12: applyMaskAmountComdinheiro(rr12.perda_maxima) || " - ",
                ret_max_12: applyMaskAmountComdinheiro(rr12.retorno_maximo) || " - ",
                ret_min_12: applyMaskAmountComdinheiro(rr12.retorno_minimo) || " - ",
                ret_med_12: applyMaskAmountComdinheiro(rr12.retorno_medio) || " - ",
            });
        });

        rows.sort((a, b) => {
            if (a.isBenchmark !== b.isBenchmark) return a.isBenchmark ? 1 : -1;
            return String(a.fund_name).localeCompare(String(b.fund_name));
        });

        return rows;
    }

    // ----- util de formatação -----
    function fmtPct(v) {
        if (v === null || v === undefined || isNaN(v)) return '-';
        return Number(v).toFixed(2).replace('.', ',');
    }

    // ----- Formata dados para a tabela de retornos no relatório -----
    function prepareReturnsTable(data, yearLabels, monthLabels) {
        const monthsCount = monthLabels.length;

        const rows = data.map(item => {
            const yrs = (item.returns && item.returns.years) || {};
            const monthlyAll = (item.returns && item.returns.monthly) || [];

            const lastN = monthlyAll.slice(-monthsCount);

            while (lastN.length < monthsCount) lastN.unshift(null);

            const monthlyDisplay = [...lastN].map(fmtPct);
            const yearValues = yearLabels.map(y => fmtPct(yrs[y]));

            return {
                name: item.name,
                isBenchmark: !!item.isBenchmark,
                years: yearValues,
                months12: fmtPct(item.returns?.months12),
                months24: fmtPct(item.returns?.months24),
                months36: fmtPct(item.returns?.months36),
                months48: fmtPct(item.returns?.months48),
                months60: fmtPct(item.returns?.months60),
                monthly: monthlyDisplay
            };
        });


        return {
            header: {
                years: yearLabels,
                monthLabels: monthLabels
            },
            rows
        };
    }

    async function doReport() {


        if (dataRentsChart && dataPatrimonyChart && allRiskReturnData) {

            const { valuesToRentsChart, labels: labelsRents } = getDataRentsChartByTypeAndPeriod(allRentsFundsData, 2, 1);
            const { valuesToPatrimonyChart, labels: labelsPatrimony } = getDataPatrimonyChartByPeriod(allPatrimonyData.byMonth, 2); //36 meses
            const returnsTableDataFormatted = prepareReturnsTable(returnsTableData, yearLabels, monthLabels);
            dispatch(allActions.reportLoadActions.setReportLoad({
                show: true,
                reportType: 'compareFunds',
                fundsInCompare: fundsInCompare,
                benchamrksInCompare: benchamrksInCompare,
                chartRentsMonthData: getDataRentsChart(valuesToRentsChart, labelsRents, mapCnpjsFunds),
                chartPlEvolutionData: getDataPatrimonioChart(valuesToPatrimonyChart, labelsPatrimony, mapCnpjsFunds),
                tableData: formatRiskReturnRowsToReport(allRiskReturnData, mapCnpjsFunds),
                returnsTableData: returnsTableDataFormatted,
                message: 'Gerando comparativo...',

            }))

        } else {

        }



    }

    function doExcel() {
        const now = new Date();
        const dateStr = String(now.getDate()).padStart(2, '0') + '-'
            + String(now.getMonth() + 1).padStart(2, '0') + '-'
            + now.getFullYear();
        const fileName = 'Comparativo_Fundos_' + dateStr;

        const wb = XLSX.utils.book_new();
        wb.Props = { Title: fileName, Author: 'UNO' };

        const getFundName = (key) => {
            if (mapCnpjsFunds && mapCnpjsFunds[key]) return mapCnpjsFunds[key].fund_name;
            return key.toUpperCase();
        };

        // ---- Aba 1: Retornos ----
        const returnsFormatted = prepareReturnsTable(returnsTableData, yearLabels, monthLabels);
        const retHeader = ['Fundo'];
        (returnsFormatted.header?.years || []).forEach(y => retHeader.push(String(y)));
        retHeader.push('12m', '24m', '36m', '48m', '60m');
        (returnsFormatted.header?.monthLabels || []).forEach(m => retHeader.push(m));

        const retRows = [retHeader];
        (returnsFormatted.rows || []).forEach(r => {
            const row = [r.name];
            (r.years || []).forEach(v => row.push(v));
            row.push(r.months12 || '-', r.months24 || '-', r.months36 || '-', r.months48 || '-', r.months60 || '-');
            (r.monthly || []).forEach(v => row.push(v));
            retRows.push(row);
        });
        const wsRet = XLSX.utils.aoa_to_sheet(retRows);
        wb.SheetNames.push('Retornos');
        wb.Sheets['Retornos'] = wsRet;

        // ---- Abas 2, 3 e 4: dados de risco/retorno ----
        const riskRows = formatRiskReturnRowsToReport(allRiskReturnData, mapCnpjsFunds);

        // Aba 2: Risco e Retorno (12m)
        const rrData = [['Fundo', 'Cota', 'PL', 'Cotistas', 'Perda Máx.', 'Ret. Máx.', 'Ret. Mín.', 'Ret. Médio']];
        riskRows.forEach(r => rrData.push([
            r.fund_name,
            r.cota_12 || '-',
            r.pl || '-',
            r.cotistas || '-',
            r.perda_max_12 || '-',
            r.ret_max_12 || '-',
            r.ret_min_12 || '-',
            r.ret_med_12 || '-',
        ]));
        const wsRR = XLSX.utils.aoa_to_sheet(rrData);
        wb.SheetNames.push('Risco e Retorno (12m)');
        wb.Sheets['Risco e Retorno (12m)'] = wsRR;

        // Aba 3: Volatilidade
        const volData = [['Fundo', '12m', '24m', '36m', '48m', '60m']];
        riskRows.forEach(r => volData.push([
            r.fund_name,
            r.vol_12 || '-',
            r.vol_24 || '-',
            r.vol_36 || '-',
            r.vol_48 || '-',
            r.vol_60 || '-',
        ]));
        const wsVol = XLSX.utils.aoa_to_sheet(volData);
        wb.SheetNames.push('Volatilidade');
        wb.Sheets['Volatilidade'] = wsVol;

        // Aba 4: Sharpe
        const sharpeData = [['Fundo', '12m', '24m', '36m', '48m', '60m']];
        riskRows.forEach(r => sharpeData.push([
            r.fund_name,
            r.sharpe_12 || '-',
            r.sharpe_24 || '-',
            r.sharpe_36 || '-',
            r.sharpe_48 || '-',
            r.sharpe_60 || '-',
        ]));
        const wsSharpe = XLSX.utils.aoa_to_sheet(sharpeData);
        wb.SheetNames.push('Sharpe');
        wb.Sheets['Sharpe'] = wsSharpe;

        // ---- Aba 5: Patrimônio ----
        if (allPatrimonyData && allPatrimonyData.byMonth && allPatrimonyData.byMonth.length) {
            const patCnpjs = fundsInCompare.map(f => f.cnpj);
            const patHeader = ['Data', ...patCnpjs.map(c => getFundName(c))];
            const patData = [patHeader];
            allPatrimonyData.byMonth.forEach(entry => {
                const row = [entry.data];
                patCnpjs.forEach(c => {
                    const v = entry[c];
                    row.push(v != null ? applyMaskAmountComdinheiro(v) : '-');
                });
                patData.push(row);
            });
            const wsPat = XLSX.utils.aoa_to_sheet(patData);
            wb.SheetNames.push('Patrimônio');
            wb.Sheets['Patrimônio'] = wsPat;
        }

        // ---- Aba 6: Rent. Histórica ----
        if (allRentsFundsData && allRentsFundsData.length) {
            const rentKeys = [
                ...fundsInCompare.map(f => f.cnpj),
                ...benchamrksInCompare.map(b => b.comdinheiro_name),
            ];
            const rentHeader = ['Data', ...rentKeys.map(k => getFundName(k))];
            const rentHist = [rentHeader];
            allRentsFundsData.forEach(entry => {
                const row = [entry.data];
                rentKeys.forEach(k => {
                    const v = entry[k];
                    row.push(v != null ? applyMaskAmount(v) + '%' : '-');
                });
                rentHist.push(row);
            });
            const wsRentHist = XLSX.utils.aoa_to_sheet(rentHist);
            wb.SheetNames.push('Rent. Histórica');
            wb.Sheets['Rent. Histórica'] = wsRentHist;
        }

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        downloadBlob(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), fileName + '.xlsx');
    }

    useEffect(() => {

        if (!allFunds) {
            doGetAllFunds();
            doGetAllBenchmarks();
            doGetFundsGroups();
        }

        doGetPresets();
        doCheckGroupPresetsEnabled();

        //Predefinição de carteira acompanha o mês/ano selecionado no cabeçalho (só se for do cliente atual)
        if (presetSelected && presetSelected.fund_group_id && presetSelected.only_client_funds === true
            && clientOn && clientOn.client && presetSelected.client_id === clientOn.client.id) {
            loadPreset(presetSelected);
        }

    }, [clientOn]);

    useEffect(() => {
        if (fundsInCompareDivRef && fundsInCompareDivRef.current) {
            fundsInCompareDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
        }
    }, [fundsInCompare, benchamrksInCompare])

    return (
        <div className={classes.root}>

            <div className={classes.headerSearch}>

                <Typography variant="h6" gutterBottom align="left">
                    Comparar Fundos
                </Typography>

                <div className={classes.rightHeader}>

                    {allPresets && allPresets.length > 0 ?
                        <div style={{ marginRight: '16px', display: 'flex', alignItems: 'center' }}>
                            {loadingPresetGroup ?
                                <CircularProgress size={20} style={{ marginRight: '8px' }} /> : null}
                            <MyAutoComplete
                                onChange={(event, newValue) => {
                                    if (newValue) loadPreset(newValue);
                                }}
                                customWidth={'220px'}
                                options={allPresets}
                                autoComplete
                                label={'Predefinição'}
                                value={presetSelected ? presetSelected : null}
                                getOptionLabel={(option) => option.title}
                                renderOption={(option) => (
                                    <div
                                        key={'autocomplete-preset-' + option.id}
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span className={classes.bold}>{option.title}</span>
                                            {option.fund_group_id ?
                                                <Typography variant="caption" color="textSecondary">
                                                    {option.only_client_funds ? 'Agrupamento · carteira do cliente' : 'Agrupamento · toda a base'}
                                                </Typography>
                                                : null}
                                        </div>
                                        <IconButton
                                            size={'small'}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                doDeletePreset(option);
                                            }}>
                                            <Remove fontSize={'small'} />
                                        </IconButton>
                                    </div>
                                )}
                                renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                            />
                        </div>
                        : null}



                    <MyAutoComplete
                        onChange={(event, newValue) => {
                            setFundSelectedToCompare(newValue);
                        }}
                        customWidth={'320px'}
                        options={allFunds}
                        autoComplete
                        label={'Nome do fundo ou CNPJ'}
                        filterOptions={(options, state) => {
                            if (!options) return [];
                            return options.filter(element => element.cnpj
                                .includes(state.inputValue)
                                || element.fund_name.toLowerCase().includes(state.inputValue.toLowerCase()));
                        }}
                        value={fundSelectedToCompare ? fundSelectedToCompare : null}
                        getOptionLabel={(option) => formatStringToDisplay(option.fund_name, 5, '...')}
                        renderOption={(option) => (
                            <React.Fragment key={'autocomplete-fund-compare-' + option.id}>
                                <span className={classes.bold}>{option.fund_name}</span>
                            </React.Fragment>
                        )}
                        renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                    />

                    <UnoButton
                        size={'small'}
                        style={{ marginLeft: '16px', marginRight: '16px' }}
                        onClick={() => addFundToCompare(fundSelectedToCompare)}
                        type='success'
                        startIcon={<Add />}>
                        {"FUNDO"}
                    </UnoButton>

                    <MyAutoComplete
                        onChange={(event, newValue) => {
                            setBenchmarkSelectedToCompare(newValue);
                        }}
                        customWidth={'170px'}
                        options={allBenchmarks}
                        autoComplete
                        label={'Benchmark'}
                        value={benchmarkSelectedToCompare ? benchmarkSelectedToCompare : null}
                        getOptionLabel={(option) => option.name}
                        renderOption={(option) => (
                            <React.Fragment key={'autocomplete-benchmark-' + option.id}>
                                <span className={classes.textAutoComplete}>{option.name}</span>
                            </React.Fragment>
                        )}
                        renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                    />

                    <UnoButton
                        size={'small'}
                        style={{ marginLeft: '16px', }}
                        onClick={() => addBenchmarkToCompare(benchmarkSelectedToCompare)}
                        type='warning'
                        startIcon={<Add />}>
                        {"Bench."}
                    </UnoButton>

                    {(canShowSavePresetButton() || (canManageGroupPresets && allFundsGroups && allFundsGroups.length > 0)) ?
                        <UnoButton
                            size={'small'}
                            style={{ marginLeft: '8px' }}
                            onClick={() => {
                                setPresetTitleInput("");
                                setPresetGroupInput(null);
                                setPresetOnlyClientFundsInput(false);
                                setSubmittedPreset(false);
                                setOpenPresetModal(true);
                            }}
                            type='primary'
                            startIcon={<Add />}>
                            {"Predef."}
                        </UnoButton>
                        : null}

                    {
                        inCompare && dataPatrimonyChart && dataRentsChart
                            //&& checkUserIsRole(currentUser, [roles.superadmin])
                            ?
                            <>
                                <UnoButton
                                    isIconButton
                                    onClick={(e) => setReportMenuAnchor(e.currentTarget)}
                                    size='small'
                                    type='primary'
                                />
                                <Menu
                                    anchorEl={reportMenuAnchor}
                                    keepMounted
                                    open={Boolean(reportMenuAnchor)}
                                    onClose={() => setReportMenuAnchor(null)}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                                    <MenuItem onClick={() => { setReportMenuAnchor(null); doReport(); }}>
                                        <PictureAsPdf fontSize={'small'} style={{ marginRight: '8px', color: unoTheme.mainColor }} />
                                        {'PDF'}
                                    </MenuItem>
                                    <MenuItem onClick={() => { setReportMenuAnchor(null); doExcel(); }}>
                                        <GridOn fontSize={'small'} style={{ marginRight: '8px', color: unoTheme.greenMoney }} />
                                        {'Excel'}
                                    </MenuItem>
                                </Menu>
                            </> : null
                    }

                </div>
            </div>
            <div class={'defaultScrollWithHeaderContent'}>

                {(fundsInCompare && fundsInCompare.length) || (benchamrksInCompare && benchamrksInCompare.length) ?
                    <div className={classes.fundsInCompare}>

                        <Grid container spacing={2} ref={fundsInCompareDivRef}>
                            {renderFundsInCompare(fundsInCompare)}
                            {renderBenchmarksInCompare(benchamrksInCompare)}
                        </Grid>
                    </div>
                    : null}

                {!inCompare ?
                    <div className={classes.comparativeLabel}>

                        {fundsInCompare && fundsInCompare.length >= 2 ?


                            <UnoButton
                                className={'compareButton'}
                                size={'small'}
                                style={{ marginRight: '16px' }}
                                onClick={() => doCompare(fundsInCompare, benchamrksInCompare)}
                                type='primary'>
                                {"Realizar comparativo"}
                            </UnoButton>


                            :
                            <Typography>{'Selecione os fundos que deseja comparar'}</Typography>

                        }
                    </div> : null}

                {inCompare ?
                    <div className={classes.compareCharts}>
                        <Grid container spacing={2}>

                            <Grid item lg={12} md={12} sm={12}>

                                {
                                    loadRentsFundsChart ?
                                        <div className={'loadChart loadPatrimony'}>
                                            <CircularProgress disableShrink className={classes.loadTop} color="inherit" />
                                            <Typography variant={'body1'} className={'title'}>Rentabilidades</Typography>
                                        </div>
                                        :
                                        <div className={classes.divChart}>
                                            {allRentsFundsData ?
                                                <div className={'chartHeader'}>

                                                    <Typography variant={'body1'} className={'title'}>Rentabilidades Mensais</Typography>
                                                    <div className={'right'}>
                                                        <MySelect
                                                            style={{ marginRight: '8px' }}
                                                            value={typeChartSelected}
                                                            verysmall
                                                            onChange={(e) => handleChangeTypeChartPeriod(e.target.value)}
                                                            options={typesChart.map((row, index) => (

                                                                <option key={'type-chart-' + index} value={index}>{row}</option>

                                                            ))}
                                                        />

                                                        <MySelect
                                                            value={periodRentsSelected}
                                                            verysmall
                                                            onChange={(e) => handleChangeChartRentsPeriod(e.target.value)}
                                                            options={periods.map((row, index) => (

                                                                <option key={'chart-period-rents-' + index} value={index}>{row}</option>

                                                            ))}
                                                        />
                                                    </div>
                                                </div> : null
                                            }

                                            {allRentsFundsData ?
                                                <div className={'chartWrapper2'}>
                                                    <Bar data={dataRentsChart} options={optionsChartRentsMonth} />
                                                </div>
                                                : null
                                            }



                                        </div>
                                }

                            </Grid>
                            <Grid item lg={12} md={12} sm={12}></Grid>
                            <Grid item lg={12} md={12} sm={12}>

                                {
                                    loadPatrimonyChart ?
                                        <div className={'loadChart loadPatrimony'}>
                                            <CircularProgress disableShrink className={classes.loadTop} color="inherit" />
                                            <Typography variant={'body1'} className={'title'}>Evolução de patrimônio</Typography>
                                        </div>
                                        :
                                        <div className={classes.divChart}>
                                            <div className={'chartHeader'}>

                                                <Typography variant={'body1'} className={'title'}>Evolução do Patrimônio (Em Milhões)</Typography>
                                                <div className={'right'}>
                                                    <MySelect
                                                        value={periodChartPatrimonioSelected}
                                                        verysmall
                                                        onChange={(e) => handleChangeChartPatrimonioPeriod(e.target.value)}
                                                        options={periods.map((row, index) => (

                                                            <option key={'chart-period-' + index} value={index}>{row}</option>

                                                        ))}
                                                    />
                                                </div>
                                            </div>


                                            <div className={'chartWrapper'}>
                                                <Bar data={dataPatrimonyChart} options={optionsChartPatrimonio} />
                                            </div>

                                        </div>
                                }

                            </Grid>

                            {/* NOVA TABELA DE RETORNOS - Adicionada entre o gráfico de patrimônio e a tabela de risco e retorno */}
                            <Grid item lg={12} md={12} sm={12}>
                                {returnsTableData.length > 0 && (
                                    <div className={classes.divChart}>
                                        <div className={'chartHeader'}>
                                            <Typography variant={'body1'} className={'title'}>Retornos</Typography>
                                        </div>

                                        <TableContainer className={classes.returnsTableContainer}>
                                            <Table className={classes.tableBlade} size={'small'}>
                                                <colgroup>
                                                    <col width="10%" />
                                                </colgroup>
                                                <TableHead>
                                                    <TableRow>

                                                        <TableCell align="left"></TableCell>
                                                        {/* Colunas de anos */}
                                                        {renderYearHeaders()}
                                                        <TableCell align="center">12 meses</TableCell>
                                                        <TableCell align="center">24 meses</TableCell>
                                                        <TableCell align="center">36 meses</TableCell>
                                                        <TableCell align="center">48 meses</TableCell>
                                                        <TableCell align="center">60 meses</TableCell>
                                                        {renderMonthHeaders()}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {renderReturnsTableRows()}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </Grid>

                            <Grid item lg={12} md={12} sm={12}></Grid>
                            <Grid item lg={12} md={12} sm={12}>

                                {
                                    loadRiskAndReturnTable ?
                                        <div className={'loadChart loadRiskReturn'}>
                                            <CircularProgress disableShrink className={classes.loadTop} color="inherit" />
                                            <Typography variant={'body1'} className={'title'}>Risco e Retorno</Typography>
                                        </div>
                                        :

                                        <>
                                            <div className={classes.divTable}>
                                                <div className={'chartHeader'}>
                                                    <Typography variant={'body1'} className={'title'}>Tabelas de Risco x Retorno (12m)</Typography>
                                                </div>

                                                <TableContainer>
                                                    <Table className={classes.tableBlade} size={'small'}>
                                                        <colgroup>
                                                            <col width="25%" />
                                                        </colgroup>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center"></TableCell>
                                                                <TableCell align="center">Cota</TableCell>
                                                                <TableCell align="center">PL</TableCell>
                                                                <TableCell align="center">Cotistas</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                            {allRiskReturnData ? renderRowsQuotas(allRiskReturnData) : null}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                            <br />
                                            <br />
                                            <div className={classes.divTable}>
                                                <TableContainer>
                                                    <Table className={classes.tableBlade} size={'small'}>
                                                        <colgroup>
                                                            <col width="25%" />
                                                        </colgroup>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left"></TableCell>
                                                                <TableCell align="center">Perda Máx.</TableCell>
                                                                <TableCell align="center">Retorno Máx.</TableCell>
                                                                <TableCell align="center">Retorno Mín.</TableCell>
                                                                <TableCell align="center">Retorno Médio</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {allRiskReturnData ? renderRowsReturn(allRiskReturnData) : null}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                            <br />
                                            <br />
                                            <div className={classes.divTable}>
                                                <div className={'chartHeader'}>
                                                    <Typography variant={'body1'} className={'title'}>Volatilidade</Typography>
                                                </div>
                                                <TableContainer>
                                                    <Table className={classes.tableBlade} size={'small'}>
                                                        <colgroup>
                                                            <col width="25%" />
                                                        </colgroup>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center"></TableCell>
                                                                <TableCell align="center">12 Meses</TableCell>
                                                                <TableCell align="center">24 Meses</TableCell>
                                                                <TableCell align="center">36 Meses</TableCell>
                                                                <TableCell align="center">48 Meses</TableCell>
                                                                <TableCell align="center">60 Meses</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {allRiskReturnData ? renderRowsVolatility(allRiskReturnData) : null}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                            <br />
                                            <br />
                                            <div className={classes.divTable}>
                                                <div className={'chartHeader'}>
                                                    <Typography variant={'body1'} className={'title'}>Sharpe</Typography>
                                                </div>
                                                <TableContainer>
                                                    <Table className={classes.tableBlade} size={'small'}>
                                                        <colgroup>
                                                            <col width="25%" />
                                                        </colgroup>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center"></TableCell>
                                                                <TableCell align="center">12 Meses</TableCell>
                                                                <TableCell align="center">24 Meses</TableCell>
                                                                <TableCell align="center">36 Meses</TableCell>
                                                                <TableCell align="center">48 Meses</TableCell>
                                                                <TableCell align="center">60 Meses</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {allRiskReturnData ? renderRowsSharpe(allRiskReturnData) : null}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>

                                        </>
                                }

                            </Grid>

                        </Grid>
                    </div> : null}

            </div>

            <Dialog open={openPresetModal} onClose={() => setOpenPresetModal(false)} fullWidth maxWidth={'xs'}>
                <DialogTitle>Nova Predefinição</DialogTitle>
                <DialogContent>
                    <MyTextField
                        outerlabel={'Título'}
                        placeholder="Insira o título da predefinição"
                        value={presetTitleInput}
                        onChange={(v) => setPresetTitleInput(v)}
                        validator={submittedPreset && (presetTitleInput.trim() === "" || presetNameExists(presetTitleInput))}
                        helperText={presetTitleInput.trim() === "" ? "Insira o título" : "Já existe predefinição com esse nome"} />

                    {canManageGroupPresets && allFundsGroups && allFundsGroups.length > 0 ?
                        <div style={{ marginTop: '16px' }}>
                            <MyAutoComplete
                                onChange={(event, newValue) => {
                                    setPresetGroupInput(newValue);
                                }}
                                options={allFundsGroups}
                                autoComplete
                                outerlabel={'Agrupamento de fundos (opcional)'}
                                label={'Agrupamento de fundos (opcional)'}
                                value={presetGroupInput ? presetGroupInput : null}
                                getOptionLabel={(option) => option.title}
                                getOptionSelected={(option, value) => option.id === value.id}
                                renderOption={(option) => (
                                    <React.Fragment key={'autocomplete-preset-group-' + option.id}>
                                        <span>{option.title}</span>
                                    </React.Fragment>
                                )}
                                renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                            />

                            {presetGroupInput ?
                                <MyRadioGroup
                                    outerlabel={'Fundos exibidos'}
                                    aria-label="preset-funds-scope"
                                    name="preset_funds_scope"
                                    value={presetOnlyClientFundsInput ? 'CLIENT' : 'ALL'}
                                    onChange={(e) => setPresetOnlyClientFundsInput(e.target.value === 'CLIENT')}
                                    options={[
                                        <FormControlLabel
                                            key={'preset-funds-scope-all'}
                                            value={'ALL'}
                                            control={<Radio />}
                                            label={<span>Todos os fundos da base</span>} />,
                                        <FormControlLabel
                                            key={'preset-funds-scope-client'}
                                            value={'CLIENT'}
                                            control={<Radio />}
                                            label={<span>Apenas os fundos da carteira do cliente</span>} />,
                                    ]} />
                                : null}

                            <Typography variant="caption" color="textSecondary">
                                Ao selecionar um agrupamento, os fundos enquadrados nele serão carregados ao aplicar a predefinição.
                            </Typography>
                        </div>
                        : null}
                </DialogContent>
                <DialogActions>
                    <UnoButton onClick={() => setOpenPresetModal(false)} type="defaultClean">Voltar</UnoButton>
                    <UnoButton onClick={doSavePreset} type="primary">Salvar</UnoButton>
                </DialogActions>
            </Dialog>

        </div >
    );
}